import React from "react";
import { useTranslate } from "react-admin";

const EmptyMessage = () => {
  const t = useTranslate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        textAlign: "center",
        minHeight: "200px",
      }}
    >
      <span style={{ fontSize: "24px", marginBottom: "1rem" }}>📭</span>
      <p style={{ color: "#666" }}>
        {t("resources.notifications.errors.no_record")}
      </p>
    </div>
  );
};

export default EmptyMessage;
